import Display from "./components/Display";
function App() {
  return (
    <div className="App w-screen h-screen flex justify-center items-center bg-neutral-800">
      <Display />
    </div>
  );
}

export default App;
